import { render, staticRenderFns } from "./TipsContent.vue?vue&type=template&id=7af50fef&"
import script from "./TipsContent.vue?vue&type=script&lang=js&"
export * from "./TipsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports